
import AutocompleteComponent from '../../../../autocomplete-component/src/AutocompleteComponent';

const utils = require('./helpers/utils');
const GoogleMapsLoader = require('google-maps');
const breakpointPX = 767;
let googleMaps;
// TODO DELETE
const API_KEY = require('../../../../api_key.json').API_KEY;

export default {
  components: {
    AutocompleteComponent
  },
  name: 'MapComponent',

  data() {
    return {
      mapConfig: require('./defaultMapConfig/mapConfig.json'),
      autocompleteConfig: null,
      mobile: null,
      map: false,
      mapCenter: null,
      markers: [],
      originalBounds: {
      },
      paddingBounds: {
        bottom: 50,
        top: 50,
        left: 50,
        right: 50
      },
      prioritaryClickTime: 0,
      googleMaps: {
        event: {},
        controlPositions: {}
      }
    };
  },
  props: {
    autocompleteConfig: {
      type: Object,
      required: true
    }
  },
  watch: {

  },
  methods: {
    createMap: async function () {
      try {
        let mapOptions = this.mapConfig.mapOptions;
        const mapBounds = this.mapConfig.defaultBounds;
        GoogleMapsLoader.KEY = API_KEY;
        GoogleMapsLoader.VERSION = this.mapConfig.mapVersion || 'quarterly';
        GoogleMapsLoader.LANGUAGE = this.mapConfig.language;
        this.map = await this.generateMap(mapOptions, mapBounds);
        if (!GoogleMapsLoader.isLoaded()) {
          console.log('error loading map');
        }

        googleMaps.event.addListenerOnce(this.map, 'idle', () => {
          this.mapCenter = this.map.getCenter().toUrlValue();
          this.addMapListeners();
        });
        this.addAutocomplete();
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
      }
    },
    generateMap(mapOptions, mapBounds) {
      return new Promise((resolve) => {
        GoogleMapsLoader.load((google) => {
          this.loadGoogleMaps();
          mapOptions.zoomControlOptions = {
            position: googleMaps.ControlPosition.TOP_RIGHT
          };
          let restriction = {
            latLngBounds: googleMaps.LatLngBounds({
              lat: -89,
              lng: -179
            }, {
              lat: 89,
              lng: 179
            }),
            strictBounds: true
          };
          mapOptions = Object.assign({}, mapOptions, {
            restriction: restriction,
            gestureHandling: 'greedy'
          });
          let map = googleMaps.Map(this.$refs.mapContainer, mapOptions);
          this.originalBounds = googleMaps.getBounds(mapBounds);
          map.fitBounds(this.originalBounds, this.paddingBounds);
          this.manageZoomControl(map);
          resolve(map);
        });
      }).catch((error) => {
        // eslint-disable-next-line
        console.log(error);
      });
    },
    loadGoogleMaps() {
      googleMaps = require('./helpers/googleHelper');
      this.googleMaps = googleMaps;
    },
    addMapListeners() {
      googleMaps.event.addDomListener(window, 'resize', () => {
        this.manageZoomControl(this.map);
      });
      googleMaps.event.addListener(this.map, 'bounds_changed', () => {
        this.mapCenter = this.map.getCenter().toUrlValue();
      });

    },

    manageZoomControl(map) {
      if (this.mobile !== this.$el.offsetWidth < breakpointPX) {
        this.mobile = this.$el.offsetWidth < breakpointPX || utils.isMobileDevice();
        map.setOptions({
          zoomControl: !this.mobile
        });
      }
    },

    addAutocomplete() {
      this.map.controls[this.googleMaps.ControlPosition['TOP_LEFT']].push(this.$refs.autocomplete.$el);
    },

    selectItem(item) {
      console.log('selected item:', JSON.stringify(item));
      this.removeMarkers();
      if (item.latitude && item.longitude) {
        let marker = {
          position: googleMaps.LatLng(item.latitude, item.longitude),
          content: `<div class='marker ${item.origin}-marker'></div>`,
          map: this.map,
          shadow: 0,
          data: item
        };
        let richMarker = googleMaps.richmarker(marker);
        richMarker.setZIndex(1);
        this.markers.push(richMarker);
      } else {
        console.log('Not lat/lng');
      }
    },
    removeMarkers() {
      this.markers.forEach((m) => {
        m.setMap(null);
      });
      this.markers = [];
    },
    clearItem() {
      console.log('clear item');
      this.removeMarkers();
    },
    editing(isEditing) {
      console.log('isEditing', isEditing);
    }
  },
  async mounted() {
    await this.createMap();
  }
};



// WEBPACK FOOTER //
// ./demo/components/map-component/src/MapComponent.view.js